import { Yates } from "../api";
import {
  setYatesValue,
  showLoading,
  setQuotation,
  decreaseStepByOne
} from "../actions";

export function getDatosYates() {
  return function func(dispatch) {
    Yates.getTarifas().then(response => {
      if (response) {
        dispatch(setYatesValue('tarifas', response));
      }
    });
    Yates.getMotores().then(response => {
      if (response) {
        dispatch(setYatesValue('motores', response));
      }
    });
    Yates.getMateriales().then(response => {
      if (response) {
        dispatch(setYatesValue('materiales', response));
      }
    });
    Yates.getTiposBarco().then(response => {
      if (response) {
        dispatch(setYatesValue('tiposBarco', response));
      }
    });
    Yates.getBanderas().then(response => {
      if (response) {
        dispatch(setYatesValue('banderas', response));
      }
    });
  };
}

export function getZonasResidencia() {
  return function func(dispatch) {
    Yates.getZonasResidencia().then(response => {
      if (response) {
        dispatch(setYatesValue('zonasResidencia', response));
      }
    });
  };
}

export function getMarinas() {
  return function func(dispatch, getState) {

    const { zonaResidencia } = getState().yates;
    const { value: codigoZona } = zonaResidencia;

    dispatch(setYatesValue('marina', null));

    Yates.getMarinas(codigoZona).then(response => {
      if (response) {
        dispatch(setYatesValue('marinas', response));
      }
    });
  };
}

export function getQuotation() {
  return function func(dispatch, getState) {

    const { nombre, tarifa, marca, material, eslora, tipoBarco,
      accidente, año, motorMarca, manga, valor, bandera, velocidad } = getState().yates;
    const { quoter } = getState().options;

    const request = {
      nombre, 
      tarifa: tarifa.value, 
      marca, 
      material: material.value, 
      eslora, 
      tipoBarco: tipoBarco.value,
      accidente: accidente.value, 
      año: año.value, 
      motor: motorMarca.value, 
      manga, 
      valor, 
      bandera: bandera.value, 
      velocidad
    };
    
    dispatch(showLoading(true));

    return Yates.getQuotation(request).then(resQuotation => {
      if (resQuotation) {
        Yates.getPlanPagos().then(resPlanPagos => {
          if (resPlanPagos) {
            dispatch(setQuotation(quoter, { quotation: resQuotation, paymentsPlan: resPlanPagos }));
          } else {
            dispatch(decreaseStepByOne());
            // console.log('Error al obtener el plan de pagos');
          }
        });
      } else {
        // dispatch(decreaseStepByOne());
        dispatch(setQuotation(quoter, { respuesta: { mensaje: 'Error al obtener la cotización' }}));
      }

      dispatch(showLoading(false));
    });
  };
}